import fontawesome from '@fortawesome/fontawesome'
import {
  faAngleDown,
  faAngleRight,
  faArrowAltCircleRight,
  faAt,
  faBell,
  faCircle,
  faClipboard,
  faClock,
  faCog,
  faComment,
  faCopy,
  faEdit,
  faEllipsisH,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileImage,
  faKey,
  faLink,
  faPencilAlt,
  faShare,
  faSignOutAlt,
  faSpinner,
  faSyncAlt,
  faTags,
  faTicketAlt,
  faTimes,
  faTrash,
  faUpload
} from '@fortawesome/fontawesome-free-solid'

fontawesome.config = { autoAddCss: true }

fontawesome.library.add(faAngleDown)
fontawesome.library.add(faAngleRight)
fontawesome.library.add(faArrowAltCircleRight)
fontawesome.library.add(faAt)
fontawesome.library.add(faBell)
fontawesome.library.add(faCircle)
fontawesome.library.add(faClipboard)
fontawesome.library.add(faClock)
fontawesome.library.add(faCog)
fontawesome.library.add(faComment)
fontawesome.library.add(faCopy)
fontawesome.library.add(faEdit)
fontawesome.library.add(faEllipsisH)
fontawesome.library.add(faExclamationTriangle)
fontawesome.library.add(faEye)
fontawesome.library.add(faEyeSlash)
fontawesome.library.add(faFile)
fontawesome.library.add(faFileAlt)
fontawesome.library.add(faFileImage)
fontawesome.library.add(faKey)
fontawesome.library.add(faLink)
fontawesome.library.add(faPencilAlt)
fontawesome.library.add(faShare)
fontawesome.library.add(faSignOutAlt)
fontawesome.library.add(faSpinner)
fontawesome.library.add(faSyncAlt)
fontawesome.library.add(faTags)
fontawesome.library.add(faTicketAlt)
fontawesome.library.add(faTimes)
fontawesome.library.add(faTrash)
fontawesome.library.add(faUpload)



// WEBPACK FOOTER //
// ./src/vendor/font-awesome.js